import { Vector2Tuple, Vector3 } from 'three';

import { NavMeshQuery } from '@spazious/dollhouse-navmesh';

const _movement = new Vector3();
const _target = new Vector3();
const _start = new Vector3();
export const movePolygonInNavMesh = (
  corners: Vector2Tuple[],
  movement: Vector3,
  navMeshQuery: NavMeshQuery
): { movement: Vector3; distance: number; success: boolean } => {
  // for each corner of the polygon, check if target is out of navmesh
  // if so find the nearest point on navmesh for that corner
  // select the movement with least distance as the result
  let iteration = corners.length + 1;
  const currentMovement = movement.clone();
  let success = false;
  while (iteration-- > 0 && !success) {
    success = true;
    for (let i = 0; i < corners.length; i++) {
      _start.set(corners[i][0], 0, corners[i][1]);
      _target.copy(_start).add(currentMovement);
      const result = navMeshQuery.findClosestPoint(_target, {
        halfExtents: { x: 50, y: 50, z: 50 },
      });
      const dist = _target.distanceTo(result.point);
      if (!result.isPointOverPoly && dist > 0.0005) {
        _movement.copy(result.point).sub(_start);
        currentMovement.copy(_movement);
        success = false;
        break;
      }
    }
  }

  const selectedMovement = success ? currentMovement : currentMovement.setScalar(0);
  return {
    movement: selectedMovement,
    distance: selectedMovement.lengthSq(),
    success,
  };
};
